import React from 'react';
import cn from 'classnames';
import Card from '../../../Card';
import IconBlock from '../IconBlock';
import NameBlock from '../NameBlock';
import { AttachmentProvider } from '../../providers/attachment';
import MetaBlock from '../MetaBlock';
import styles from './index.module.scss';

const AttachmentCard = ({
  attachment,
  className,
  actions,
  shouldRenderMeta = true,
  children,
}) => {
  return (
    <AttachmentProvider attachment={attachment}>
      <Card className={cn(styles.root, className)}>
        <div className={styles.header}>
          <div className={styles.headerMain}>
            <IconBlock />
            <NameBlock />
          </div>

          {actions && <div className={styles.headerActions}>{actions}</div>}
        </div>
        {children}
        {shouldRenderMeta && <MetaBlock />}
      </Card>
    </AttachmentProvider>
  );
};

export default AttachmentCard;
